import { useSubscription } from '@apollo/client'; // eslint-disable-line no-restricted-imports
import { useDownloadReceivedData, useDownloadSentData } from '../fileHandling';
import { REPORT_WORKFLOW_COMPLETED_SUBSCRIPTION } from './subscriptions';
import { useContext, useState } from 'react';
import { useQuery } from 'hooks/apollo';
import { INTERROGATION_SETTINGS_QUERY } from './queries';
import { ServiceContext } from 'providers/ServiceProvider';
import { useToast } from 'hooks/toasts/useToast';
import { useTranslation } from 'react-i18next';

const useReportVerificationHandlers = () => {
  const { t } = useTranslation();
  const [activeService] = useContext(ServiceContext);
  const addToast = useToast();

  const [interrogationSettings, setInterrogationSettings] = useState();
  const [dataIsProcessing, setDataIsProcessing] = useState(false);

  const { loading: interrogationSettingsLoading } = useQuery(INTERROGATION_SETTINGS_QUERY, {
    fetchPolicy: 'network-only',
    onCompleted: data => {
      setInterrogationSettings(data.interrogationSettings);
    }
  });

  const [downloadSentData] = useDownloadSentData({
    activeService: activeService,
    onError: error => {
      addToast(error, 'error');
    },
    onCompleted: () => {
      addToast(t('ReportsVerification.DownloadSentData'), 'success');
    }
  });

  const [downloadReceivedData] = useDownloadReceivedData({
    activeService: activeService,
    onError: error => {
      addToast(error, 'error');
    },
    onCompleted: () => {
      addToast(t('ReportsVerification.DownloadReceivedData'), 'success');
    }
  });

  const getRequestUrl = serviceName => {
    let url = interrogationSettings.find(x => x.service === serviceName)?.communicationTypeMethod;
    return url;
  };

  const handleDownloadSentData = (requestId, serviceName) => {
    if (requestId && !interrogationSettingsLoading) {
      let url = getRequestUrl(serviceName);
      downloadSentData(parseInt(requestId), url);
    }
  };

  const handleDownloadReceivedData = (requestId, serviceName) => {
    if (requestId && !interrogationSettingsLoading) {
      let url = getRequestUrl(serviceName);
      downloadReceivedData(parseInt(requestId), url);
    }
  };

  useSubscription(REPORT_WORKFLOW_COMPLETED_SUBSCRIPTION, {
    onData: ({ client }) => {
      addToast(t('ReportsVerification.ImportedData'), 'success');
      setDataIsProcessing(false);
      client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'pagedReportsVerification' });
      client.cache.gc();
    }
  });

  return { dataIsProcessing, setDataIsProcessing, handleDownloadSentData, handleDownloadReceivedData };
};

export default useReportVerificationHandlers;
